import { styled, disabledProps } from "../../../styled-components";

export const UserProfileImageSize = 150;

export const UserProfileMadeWithGlide = styled.a`
    padding: 14px;
`;

export const UserProfileStyle = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;

    :not(:last-child) {
        flex: 0;

        ${UserProfileMadeWithGlide} {
            padding-bottom: 0;
        }
    }

    margin: ${p => p.theme.componentInnerVerticalPadding}px ${p => p.theme.pageMarginMedium}px;

    & img.up-uploading {
        ${disabledProps}
    }
`;

export const UserProfileImageContainer = styled.div`
    width: ${UserProfileImageSize}px;
    height: ${UserProfileImageSize}px;
    position: relative;
    margin-bottom: 10px;
    display: flex;
    justify-content: center;
    align-items: center;

    & input {
        width: 0px;
        height: 0px;
        opacity: 0;
        z-index: -1;
    }
`;

export const UserProfileCancelContainer = styled.div<{ bg: string }>`
    width: 36px;
    height: 36px;
    background-color: ${p => p.bg};

    display: flex;
    justify-content: center;
    align-items: center;

    border-radius: 50%;
    border: solid;
    border-width: 2px;
    border-color: ${p => p.theme.baseColor};
`;

export const UserProfileInteriorProgress = styled.div<{ tr: string; br: string; bl: string; tl: string }>`
    position: absolute;
    z-index: 50;
    top: 0;
    left: 0;

    width: ${UserProfileImageSize}px;
    height: ${UserProfileImageSize}px;
    border-radius: 50%;
    border-width: 3px;

    transform: rotate(0.125turn);
    border: solid;
    border-color: ${p => p.tr} ${p => p.br} ${p => p.bl} ${p => p.tl};
`;

export const UserProfileExteriorProgress = styled.div<{ bgColor: string; rotationOffset: number }>`
    position: absolute;
    z-index: 51;
    top: 0;
    left: 0;

    width: ${UserProfileImageSize}px;
    height: ${UserProfileImageSize}px;
    border-radius: 50%;
    border-width: 3px;

    transform: rotate(calc(0.125turn + ${p => p.rotationOffset}turn));
    border: solid;
    border-color: ${p => p.bgColor} #00000000 #00000000 #00000000;
`;

export const UserProfileUploadLabel = styled.label`
    color: ${p => p.theme.fgColorLight};
    position: absolute;
    top: 0;
    left: 0;

    & > svg {
        width: ${UserProfileImageSize}px;
        height: ${UserProfileImageSize}px;

        z-index: 55;
    }

    & > img,
    & > canvas {
        border-radius: 50%;
        width: ${UserProfileImageSize}px;
        height: ${UserProfileImageSize}px;
        max-width: ${UserProfileImageSize}px;
        max-height: ${UserProfileImageSize}px;

        overflow: hidden;
        object-fit: contain;
    }
`;

export const UserProfileUploadIcon = styled.div`
    position: absolute;
    top: 60.4%;
    left: 70.8%;

    z-index: 55;
`;

export const UserProfileTextContainer = styled.div`
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
`;

export const UserProfileTitle = styled.div`
    color: ${p => p.theme.userProfile.title.textColor};
    ${p => p.theme.userProfile.title.fontStyle};
    margin-bottom: ${p => p.theme.userProfile.title.marginBottom}px;
`;

export const UserProfileSubtitle = styled.div`
    color: ${p => p.theme.userProfile.subtitle.textColor};
    ${p => p.theme.userProfile.subtitle.fontStyle};
`;
